import { EventTypes, emitter } from '../event';
import { AuthClient } from '../lib/base';
import { ClientType } from '../types';

interface ClientOptions {
  clientType: ClientType;
}

class PartnerAppClient extends AuthClient<ClientOptions> {
  private readonly clientType: ClientType;
  public token: string | null = null;

  constructor(opts: ClientOptions) {
    super(opts);
    this.clientType = opts.clientType;
  }

  init() {
    if (this.started) {
      return;
    }

    emitter.emit(EventTypes.ClientInitialized, this.clientType);

    window.addEventListener('message', this.handleMessage);

    // This is required for Android: https://github.com/react-native-webview/react-native-webview/issues/3776#issuecomment-2966259752
    if (window.navigator.userAgent.includes('Android')) {
      // @ts-expect-error TS2769
      document.addEventListener('message', this.handleMessage);
    }

    if (!window.ReactNativeWebView) {
      throw new Error('window.ReactNativeWebView is not defined');
    }
    window.ReactNativeWebView.postMessage('getAccessToken');
    this.started = true;
  }

  private handleMessage = (event: MessageEvent<string>) => {
    let payload;
    try {
      payload = JSON.parse(event.data);
    } catch {
      // Ignore non-JSON messages.
      return;
    }

    if (payload?.type === 'uwPartnerAppAccessToken') {
      if (!this.authenticated) {
        this.authenticated = true;
        emitter.emit(EventTypes.ActiveClient, this.clientType);
      }
      this.token = payload.accessToken;
    }
  };

  logout(): void {
    this.authenticated = false;
    this.token = null;
    window.removeEventListener('message', this.handleMessage);
    // @ts-expect-error TS2769
    document.removeEventListener('message', this.handleMessage);
  }

  async getOrRenewToken() {
    return this.token;
  }

  login(): void {
    throw new Error('Method not implemented.');
  }

  handleRedirect(): void {
    throw new Error('Method not implemented.');
  }
}

export { PartnerAppClient };
